<template>
  <div>
    <div class="modal-overlay">
      <div class="mmodal-content" style="max-width: 70vw">
        <div class="modal-header">
          <h5 class="modal-title">Add Lab Results</h5>
          <button type="button" class="close" @click="closeModal">
            &times;
          </button>
        </div>

        <div class="modal-body">
          <form @submit="submitForm">
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Test Notes</label>
              <div class="col-sm-10">
                <textarea
                  v-model="testNotes"
                  style="width: 100%"
                  rows="8"
                ></textarea>
              </div>
            </div>

            <fieldset class="form-group">
              <div class="row">
                <legend class="col-form-label col-sm-2 pt-0">Results</legend>
                <div class="col-sm-10">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="positive"
                      value="Positive"
                      v-model="result"
                    />
                    <label class="form-check-label" for="positive"
                      >Positive</label
                    >
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="negative"
                      value="Negative"
                      v-model="result"
                    />
                    <label class="form-check-label" for="negative"
                      >Negative</label
                    >
                  </div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      id="notapplicable"
                      value="NotApplicable"
                      v-model="result"
                    />
                    <label class="form-check-label" for="negative"
                      >Not applicable</label
                    >
                  </div>
                </div>
              </div>
            </fieldset>

            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Attach File</label>
              <div class="col-sm-10">
                <input type="file" @change="handleFileUpload" />
              </div>
            </div>

            <div class="form-group row">
              <div class="col-sm-10">
                <button
                  type="submit"
                  class="btn btn-primary"
                  style="float: right"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <ConsumablesModal
      :conducted_record="service_record"
      v-if="showConsumablesModal"
      @hide-consumables-model="hideConMod"
      @consumables-submitted="handleConsumablesSubmitted"
    />
  </div>
</template>

<script>
import { generalApiRequest, generalApiUploadRequest } from "@/api/apiIndex.js";
import ConsumablesModal from "./ConsumablesModal.vue"; // Import the new component

export default {
  name: "ModalContent",
  components: {
    ConsumablesModal, // Register the new component
  },
  props: {
    service_id: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      testNotes: "",
      result: "Positive",
      file: null,
      service_record: null,
      showConsumablesModal: false, // New data property to control the second modal
    };
  },
  methods: {
    closeModal() {
      // This will now close both modals, if open
      this.$emit("hide-create-test-model");
    },
    hideConMod() {
      this.showConsumablesModal = false;
      this.closeModal();
    },
    async submitForm(e) {
      e.preventDefault();

      const formData = new FormData();
      formData.append("service_id", this.service_id);
      formData.append("result", this.result);
      formData.append("note", this.testNotes);
      if (this.file) {
        formData.append("file", this.file);
      }

      try {
        // Use await to get the result of the API call
        const res = await generalApiUploadRequest(
          "clinical-results",
          formData,
          1
        );

        // Chain .then() to handle a successful response
        Promise.resolve(res)
          .then((result) => {
            // console.log("Submitted Lab Result:", result);
            this.service_record = result.data;

            this.showConsumablesModal = true;
          })
          // Chain .catch() to handle any errors that occurred in the promise chain
          .catch((error) => {
            console.error("Error submitting result:", error);
          })
          // Chain .finally() for code that must run regardless of success or failure
          .finally(() => {
            console.log("Lab results submission process complete.");
            // this.closeModal();
          });
      } catch (error) {
        // This catch block handles errors from the initial `await` call itself
        console.error("An error occurred during the API request:", error);
      }
    },
    // async submitForm(e) {
    //   e.preventDefault();

    //   const formData = new FormData();
    //   formData.append("service_id", this.service_id);
    //   formData.append("result", this.result);
    //   formData.append("note", this.testNotes);
    //   if (this.file) {
    //     formData.append("file", this.file);
    //   }

    //   try {
    //     const res = await generalApiUploadRequest(
    //       "clinical-results",
    //       formData,
    //       1
    //     );

    //     console.log("Submitted Lab Result:", res);
    //     this.showConsumablesModal = true;
    //     this.$emit("hide-create-test-model");
    //   } catch (error) {
    //     console.error("Error submitting result:", error);
    //   }
    // },

    handleFileUpload(event) {
      this.file = event.target.files[0];
    },
    async getTestData() {
      const url = `services/get_results_by_id/${this.service_id}`;
      const response = await generalApiRequest(url, "GET", {}, 1);
      if (response.data.id) {
        this.testNotes = response.data.note;
        this.result = response.data.result;
      }
      console.log(response);
    },
    handleConsumablesSubmitted(consumablesData) {
      // This method can be used to handle the data coming from the consumables modal
      console.log("Consumables data received in parent:", consumablesData);
      // You can now send this data to your backend API
      // After this, you should close the consumables modal
      this.showConsumablesModal = false;
    },
  },
  mounted() {
    console.log(this.service_id);
    this.getTestData();
  },
};
</script>
